import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import timeplanUnitValid from '../timeplanUnitValid';
import * as styles from '../timeplan.css';
import { TimeplanUnitRecord } from '../../../../entities/records';
import { useTranslation } from 'react-i18next';

function Warnings({ showWarnings, overlaps, duplicates, timeplanUnit }) {
  const { t } = useTranslation();
  if (!showWarnings) {
    return null;
  }

  return (
    <React.Fragment>
      {overlaps && (
        <div className={classNames('alert alert-warning text-center', styles.timeWarning2)}>
          {t("Något av passen överlappar denna dag!")}
        </div>
      )}
      {duplicates && (
        <div className={classNames('alert alert-warning text-center', styles.timeWarning2)}>
          {t("Något av passen är en dublett denna dag!")}
        </div>
      )}
      {!timeplanUnitValid(timeplanUnit) && (
        <div className={classNames('alert alert-danger text-center', styles.timeWarning2)}>
          {t("Ange korrekt tid för denna dag!")}
        </div>
      )}
    </React.Fragment>
  );
};

Warnings.propTypes = {
  showWarnings: PropTypes.bool.isRequired,
  timeplanUnit: PropTypes.instanceOf(TimeplanUnitRecord).isRequired,
  overlaps: PropTypes.bool.isRequired,
  duplicates: PropTypes.bool.isRequired,
};

export default Warnings;
